import { useEffect } from "react";
import { useOverlayContext } from "@/contexts/OverlayContext";

export function useOverlayTrigger(isOpen: boolean) {
  const { registerOverlay, unregisterOverlay } = useOverlayContext();

  useEffect(() => {
    if (isOpen) {
      registerOverlay();
      return () => unregisterOverlay();
    }
  }, [isOpen, registerOverlay, unregisterOverlay]);
}
